import { PedigreeChart } from './pedigree-chart';

export * from './pedigree-chart-node-label';

export default PedigreeChart;
